/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Content } from '../../models/content';
import { CreateContentDto } from '../../models/create-content-dto';

export interface PhaseControllerAddContentToPhase$Params {
  phaseId: string;
      body: CreateContentDto
}

export function phaseControllerAddContentToPhase(http: HttpClient, rootUrl: string, params: PhaseControllerAddContentToPhase$Params, context?: HttpContext): Observable<StrictHttpResponse<Content>> {
  const rb = new RequestBuilder(rootUrl, phaseControllerAddContentToPhase.PATH, 'post');
  if (params) {
    rb.path('phaseId', params.phaseId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Content>;
    })
  );
}

phaseControllerAddContentToPhase.PATH = '/phase/{phaseId}/content';
